// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"2d671247212a50cffe52","655":"51f30fd3c52308c05d99"}[chunkId] + ".js";
};